import type { Plugin } from 'bundles/coursera-toolbar/types/Plugin';

/**
 * Registry for coursera toolbar plugins
 */
class PluginRegistry {
  private plugins: Plugin[] = [];

  /**
   * Register a plugin with the toolbar
   */
  register = (plugin: Plugin) => {
    if (this.getPlugin(plugin.id)) {
      // Plugin already registered, do nothing
      return;
    }

    this.plugins.push(plugin);

    // Sort plugins by order
    this.plugins.sort((a, b) => {
      const orderA = a.order ?? 999;
      const orderB = b.order ?? 999;
      return orderA - orderB;
    });
  };

  /**
   * Get all registered plugins
   */
  getPlugins = () => {
    return this.plugins;
  };

  /**
   * Get a plugin by ID
   */
  getPlugin = (id: string) => {
    return this.plugins.find((plugin) => plugin.id === id);
  };
}

// Create a singleton instance
const registry = new PluginRegistry();

export default registry;
